// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"2ace51916b00a998810e","269":"594275b246825c71e3c4","525":"abd68438acdd6cb6dfc3"}[chunkId] + ".css";
};